module.exports = __webpack_public_path__ + "static/media/worker_inactive.d3cd2564.svg";